<template>
  <div
    v-if="!isItDuplicateMarket(odd, tabIdx)"
    :class="[
      'bto-sb-event-mormarket-market',
      'bto-sb-mormarket',
      { 'bto-sb-market-correct-score': marketIsCorrectScore(odd.marketId) },
    ]">
    <div
      :class="[
        'bto-sb-event-mormarket-market-name',
        'bto-sb-bar-filter',
        'bto-sb-mormarket-name',
        {
          'bto-sb-event-market-cashout bto-sb-mormarket-cashout':
            cashoutEnabledDB && showCashoutIcon && odd.cashout,
        },
      ]">
      <template v-if="odd.marketDescription && showHideMarketTooltips">
        <span class="bto-sb-tooltip" :style="tooltipEnabled ? styleObject : null" :ref="'tooltip'">
          <strong class="bto-sb-tooltip-info">{{ odd.marketDescription }}</strong>
          <strong class="bto-sb-tooltip-arrow"></strong>
        </span>
        <div class="bto-sb-event-market-info">
          <i @click.stop="toggleTooltip(odd.marketId)" class="bto-app-info-ov" id="tooltip-trigger"></i>
        </div>
      </template>
      <i v-if="!isItAgentEnv" :class="{ 'bto-app-cash': cashoutEnabledDB && showCashoutIcon && odd.cashout }"></i>
      <h4 class="bto-sb-mormarket-title">{{ odd.enrichedMarketName || odd.marketName }}</h4>
      <div v-if="marketIsCorrectScore(odd.marketId)" class="bto-sb-bar-filtertype">
        <a
          href="javascript:void(0);"
          :class="{ 'bto-sb-bar-filtertype-active': !oddViewAll[oddIdx] }"
          @click="toggleView(oddIdx)">
          {{ t("W.Slider") }}
        </a>
        <a
          href="javascript:void(0);"
          :class="{ 'bto-sb-bar-filtertype-active': oddViewAll[oddIdx] }"
          @click="toggleView(oddIdx)">
          {{ t("Mobile.all") }}
        </a>
      </div>
    </div>
    <odd-row-sliders-component
      v-if="marketIsCorrectScore(odd.marketId) && !oddViewAll[oddIdx]"
      :match="match"
      :tabIdx="tabIdx"
      :oddIdx="oddIdx" />
    <div v-else class="bto-sb-event-mormarket-market-odd bto-sb-mormarket-odd">
      <odd-column-component
        v-for="(columnNo, idx) in distinctColumns"
        :key="idx"
        :match="match"
        :tabIdx="tabIdx"
        :oddIdx="oddIdx"
        :columnNo="columnNo"
        :selectedMarket="selectedMarket" />
    </div>
    <div class="bto-sb-widget-footer" v-if="showMoreBtn && !marketIsCorrectScore(odd.marketId)">
      <div
        class="bto-sb-more-item bto-sb-show"
        v-if="!showMoreOdds[odd.marketId]"
        @click="toggleOddsDisplay(odd.marketId)">
        {{ t("Mobile.ShowMore") }}
      </div>
      <div
        class="bto-sb-more-item bto-sb-less"
        v-else-if="showMoreOdds[odd.marketId]"
        @click="toggleOddsDisplay(odd.marketId)">
        {{ t("Mobile.ShowLess") }}
      </div>
    </div>
  </div>
</template>

<script>
  import OddColumnComponent from './component-match-details-odd-column';
  import OddRowSlidersComponent from './component-match-details-odd-row-sliders';
  import store from '../../../../store';

  export default {
    name: 'TabMarketComponent',
    data() {
      return {
        /**
         * An object containing information
         * about which markets' 'all' view tab
         * is active. It is initialized to an empty
         * object because we want the 'slider' tab
         * to be selected by default.
         */
        oddViewAll: {},
        visibleOdds: +APP_SETTINGS.settings.outcomesToShowByDefault || Infinity,
        showMoreBtn: false,
        distinctColumns: [],
        styleObject: {
          display: "block",
          opacity: "1",
        }
      };
    },
    props: {
      match: {
        type: Object,
        required: true,
        default: () => { },
      },
      tabIdx: {
        type: Number,
        required: true,
        default: null,
      },
      odd: {
        type: Object,
        required: true,
        default: () => { },
      },
      oddIdx: {
        type: Number,
        required: true,
        default: null,
      },
      selectedMarket: {
        required: true,
        default: null,
      },
      isItDuplicateMarket: {
        type: Function,
        required: true,
        default: () => { },
      },
      selectedTooltip: {
        type: [Number, null],
        required: false,
        default: null,
      },
    },
    components: {
      OddColumnComponent,
      OddRowSlidersComponent,
    },
    methods: {
      marketIsCorrectScore(marketId) {
        let prematchIds = [
          32, 391, 454, 455, 456, 457, 458, 453, 219,
          154, 403, 418, 416, 417, 385, 2, 388, 332,
          464, 337, 350, 71, 72, 450, 451, 452, 448, 449
        ];

        let liveIds = [
          10, 11, 12, 29, 40, 42, 107, 131, 132, 307,
          329, 335, 359, 360, 375, 379, 524, 623, 646, 685
        ];

        let correctScoreMarketIds = this.match.isLiveMatch ? liveIds : prematchIds;

        if (correctScoreMarketIds.includes(marketId)) {
          return true;
        }
        return false;
      },
      toggleView(idx) {
        this.oddViewAll[idx] = !this.oddViewAll[idx];
        this.oddViewAll = Object.assign({}, this.oddViewAll);
      },
      /**
       * Toggle odds display defined in front settings
       * @param state
       * @param marketId
       */
      toggleOddsDisplay(idx) {
        // Toggle odds display
        store.commit('toggleOddsDisplay', idx);
      },
      toggleTooltip(marketId) {
        this.$emit("toggleTooltip", marketId);
      },
      handleClickOutsideTooltip(event) {
        const tooltip = this.$refs.tooltip;
        if (!tooltip || !this.selectedTooltip || event.target.parentNode.className === "bto-sb-tooltip") {
            return;
          }
        if (!tooltip.contains(event.target)) {
          this.$emit("toggleTooltip", this.odd.marketId);
        }
      }
    },
    computed: {
      cashoutEnabledDB() {
        return store.getters.getCashoutDbSetting;
      },
      showMoreOdds() {
        return store.state.GlobalModule.showMoreOdds;
      },
      cashoutEnabledUser() {
        return store.state.playerInfoModule.playerInfo.cashout;
      },
      showCashoutIcon() {
        return !APP_SETTINGS.player.token || this.cashoutEnabledUser;
      },
      isItAgentEnv() {
        return process.env.VUE_APP_IS_AGENT;
      },
      tooltipEnabled() {
        return this.selectedTooltip === this.odd.marketId ? true : false;
      },
      showHideMarketTooltips() {
        return APP_SETTINGS.settings.isSSBT && APP_SETTINGS.matchDetails.showMarketTooltip && APP_SETTINGS.settings.layout === "default";
      }
    },
    watch: {
      odd: {
        handler(odd) {
          const visibleOdds = +APP_SETTINGS.settings.outcomesToShowByDefault || Infinity;
          const distinctColumns = odd.outcomes.reduce((acc, o) => {
            acc[o.column] = (acc[o.column] || 0) + 1;
            return acc;
          }, {});
          if(visibleOdds) {
            this.showMoreBtn = Object.values(distinctColumns).some(o => o > visibleOdds);
          }
          this.distinctColumns = Object.keys(distinctColumns).map(k => +k).sort((a, b) => a - b);
        },
        immediate: true,
      }
    },
    mounted() {
      document.addEventListener("click", this.handleClickOutsideTooltip);
    },
    beforeDestroy() {
      document.removeEventListener("click", this.handleClickOutsideTooltip);
    }
  };
</script>
